import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Form, Row, Col, Button } from "react-bootstrap";
import _ from "lodash";
import SelectInput from "../../../../components/UI/SelectInput/SelectInput";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import FormAlert from "../../../../components/UI/FormAlert/FormAlert";
import useCancelarAiEspecial from "../hooks/useCancelarAiEspecial";
import FormOcorrencia from "./FormOcorrencia";
import FormRelCircunstanciado from "./FormRelCircunstanciado";
import useAssinarAtividadeInicial from "../hooks/useAssinarAtividadeInicial";
import useOcorrencias from "../hooks/useOcorrencias";

const validationSchema = Yup.object().shape({
  tipoAutoInfracao: Yup.string().default(""),
  descricaoOcorrencia: Yup.string()
    .default("")
    .test("verifica-texto", "Informe a descrição da Ocorrência.", (value) => {
      if (value === "<p><br></p>" || value === undefined) return false;
      return true;
    }),
  txInfringenciaComplemento: Yup.string()
    .default("")
    .test("verifica-texto", "Texto obrigatório.", (value) => {
      if (value === "<p><br></p>" || value === undefined) return false;
      return true;
    }),
  txPenalidadeComplemento: Yup.string()
    .default("")
    .test("verifica-texto", "Texto obrigatório.", (value) => {
      if (value === "<p><br></p>" || value === undefined) return false;
      return true;
    }),
  // dataPeriodoInicial: Yup.date().test("data-valida", "Período de Referência Inicial não pode ser nulo.", (value) => {
  //   if ((value || []).length === 0) return false;

  //   return true;
  // }),
  // dataPeriodoFinal: Yup.date().test("data-valida", "Período de Referência Final não pode ser nulo.", (value) => {
  //   if ((value || []).length === 0) return false;

  //   return true;
  // }),
  // dataVencimento: Yup.date().test(
  //   "data-valida",
  //   "Data de vencimento não pode ser nula ou posterior a atual.",
  //   (value) => {
  //     if ((value || []).length === 0) return false;

  //     const hoje = new Date();

  //     if (Date.parse(value) > hoje) return false;

  //     return true;
  //   },
  // ),
  txPreliminares: Yup.string()
    .default("")
    .test("texto-prel", "Texto obrigatório", (value) => {
      if (value === "<p><br></p>" || value === null || value === undefined) return false;
      return true;
    }),
  txProcedimentos: Yup.string()
    .default("")
    .test("texto-proc", "Texto obrigatório", (value) => {
      if (value === "<p><br></p>" || value === null || value === undefined) return false;
      return true;
    }),
  txConstatacoes: Yup.string()
    .default("")
    .test("texto-proc", "Texto obrigatório", (value) => {
      if (value === "<p><br></p>" || value === null || value === undefined) return false;
      return true;
    }),
  txResultado: Yup.string()
    .default("")
    .test("texto-proc", "Texto obrigatório", (value) => {
      if (value === "<p><br></p>" || value === null || value === undefined) return false;
      return true;
    }),
  txOcorrencias: Yup.string()
    .default("")
    .test("texto-proc", "Texto obrigatório", (value) => {
      if (value === "<p><br></p>" || value === null || value === undefined) return false;
      return true;
    }),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  initialValues[key] = "";
});

const TelaAIEspecialInicial = ({ dadosOs, sequencialAuto, dadosAIEspecial, siglaAtividade }) => {
  const { request: salvarRequest, data: salvarData, errors: salvarErrors, isLoading: salvarIsLoading } = useApiClient();
  const { request: requestConsulta, data: dataConsulta } = useApiClient();
  const [dadosAuto, setDadosAuto] = useState([]);
  const dadosOsRef = useRef(dadosOs);
  const siglaAtividadeRef = useRef(siglaAtividade);

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      const parametros = {
        tipoAutoInfracao: values.tipoAutoInfracao,
        sequencialAcaoFiscal: dadosOsRef.current.acaoFiscal,
        sequencialAutoInfracao: sequencialAuto,
        sequencialTipoOcorrencia: values.sequencialTipoOcorrencia,
        descricaoOcorrencia: values.descricaoOcorrencia,
        dataVencimento: values.dataVencimento,
        dataPeriodoInicial: values.dataPeriodoInicial,
        dataPeriodoFinal: values.dataPeriodoFinal,
        txInfringenciaComplemento: values.txInfringenciaComplemento,
        txPenalidadeComplemento: values.txPenalidadeComplemento,
        siglaAtividade: siglaAtividadeRef.current,
        sqItemOcorrencia: values.sqItemOcorrencia,
        txPreliminares: values.txPreliminares,
        txProcedimentos: values.txProcedimentos,
        txConstatacoes: values.txConstatacoes,
        txOcorrencias: values.txOcorrencias,
        txResultado: values.txResultado,
      };

      if (sequencialAuto > 0) {
        salvarRequest(apiRoutes.fiscalizacao.autoinfracao.alterarAtividadeInicial, parametros);
      } else {
        salvarRequest(apiRoutes.fiscalizacao.autoinfracao.incluirAtividadeInicial, parametros);
      }
    },
  });

  const { cancelarAiEspecialModal, setShowModalCancelar } = useCancelarAiEspecial({
    formik,
    dadosAIEspecial: dadosAuto.sequencialAutoAberto > 0 ? dadosAuto : dadosAIEspecial[0],
    dadosOs: dadosOsRef.current,
  });

  const { assinarAtividade, assinarIsLoading, assinarErrors } = useAssinarAtividadeInicial({
    dadosOs: dadosOsRef.current,
    sequencialAuto: sequencialAuto > 0 ? sequencialAuto : dadosAuto.sequencialAutoAberto,
    siglaAtividade: siglaAtividadeRef.current,
    formik,
  });

  const { consultaOcorrencias, dadosOcorrencia } = useOcorrencias({
    sqAcaoFiscal: dadosOsRef.current.acaoFiscal,
    tipoAutoInfracao: formik.values.tipoAutoInfracao,
    sqAutoInfracao: dadosAuto.sequencialAutoAberto,
    sqItemOcorrencia: dadosAuto.sqItemOcorrencia,
  });

  const { setSubmitting, setValues } = formik;

  useEffect(() => {
    let tipoAutoInfracao = "";
    let sqItemOcorrencia = 0;
    let txPreliminares = "";
    let txProcedimentos = "";
    let txConstatacoes = "";
    let txOcorrencias = "";
    let txResultado = "";

    if (dadosAuto?.sequencialAutoAberto > 0) {
      tipoAutoInfracao = dadosAuto?.tipoAutoAberto;
    } else {
      tipoAutoInfracao = dadosAIEspecial[0]?.tipoAutoAberto ? dadosAIEspecial[0]?.tipoAutoAberto : "";
    }

    if (dadosAuto?.sqItemOcorrencia > 0) {
      sqItemOcorrencia = dadosAuto?.sqItemOcorrencia;
    } else {
      sqItemOcorrencia = dadosAIEspecial[0]?.sqItemOcorrencia ? dadosAIEspecial[0]?.sqItemOcorrencia : 0;
    }

    if (dadosAuto?.txPreliminares !== undefined && dadosAuto?.sequencialAutoAberto > 0) {
      txPreliminares = dadosAuto?.txPreliminares;
    } else {
      txPreliminares =
        dadosAIEspecial[0]?.txPreliminares && sequencialAuto > 0
          ? dadosAIEspecial[0]?.txPreliminares
          : "Em atendimento ao Art. 44, §1º, inc. I do Decreto 13.796/98, temos a relatar: ";
    }

    if (dadosAuto?.txProcedimentos !== undefined && dadosAuto?.sequencialAutoAberto > 0) {
      txProcedimentos = dadosAuto?.txProcedimentos;
    } else {
      txProcedimentos =
        dadosAIEspecial[0]?.txProcedimentos && sequencialAuto > 0
          ? dadosAIEspecial[0]?.txProcedimentos
          : "Os procedimentos e métodos adotados na fiscalização se resumiram nas seguintes condutas: ";
    }

    if (dadosAuto?.txConstatacoes !== undefined && dadosAuto?.sequencialAutoAberto > 0) {
      txConstatacoes = dadosAuto?.txConstatacoes;
    } else {
      txConstatacoes =
        dadosAIEspecial[0]?.txConstatacoes && sequencialAuto > 0
          ? dadosAIEspecial[0]?.txConstatacoes
          : "Da investigação sobre a regularidade fiscal das operações realizadas pelo contribuinte, " +
            "no que diz respeito à legislação do ICMS, constatamos o seguinte: ";
    }

    if (dadosAuto?.txOcorrencias !== undefined && dadosAuto?.sequencialAutoAberto > 0) {
      txOcorrencias = dadosAuto?.txOcorrencias;
    } else {
      txOcorrencias =
        dadosAIEspecial[0]?.txOcorrencias && sequencialAuto > 0
          ? dadosAIEspecial[0]?.txOcorrencias
          : `Em decorrência das constatações acima descritas e dos ajustes necessários, verificamos os seguintes fatos: `;
    }

    if (dadosAuto?.txResultado !== undefined && dadosAuto?.sequencialAutoAberto > 0) {
      txResultado = dadosAuto?.txResultado;
    } else {
      txResultado =
        dadosAIEspecial[0]?.txResultado && sequencialAuto > 0
          ? dadosAIEspecial[0]?.txResultado
          : "Tendo em vista as ocorrências acima descritas, as quais resultaram nas seguintes infringências a legislação tributária do ICMS/RN: ";
    }

    setValues((curr) => ({
      ...curr,
      tipoAutoInfracao,
      sqItemOcorrencia,
      txPreliminares,
      txProcedimentos,
      txConstatacoes,
      txOcorrencias,
      txResultado,
    }));
  }, [setValues, dadosAIEspecial, sequencialAuto, dadosAuto]);

  useEffect(() => {
    if (dataConsulta && dataConsulta.result) {
      setDadosAuto(_.find(dataConsulta.result, (dados) => dados?.sequencialAutoAberto > 0));
      consultaOcorrencias();
    }
  }, [dataConsulta, consultaOcorrencias]);

  useEffect(() => {
    if (salvarIsLoading) return;

    if (!salvarData && !salvarErrors) return;

    if (salvarData) {
      toast.success(`Auto de Infração cadastrado com sucesso.`);
      const params = { sqAcaoFiscal: dadosOsRef.current.acaoFiscal };
      requestConsulta(apiRoutes.fiscalizacao.autoinfracao.consultaAutoInfracaoEsp, params);
    }

    setSubmitting(false);
  }, [salvarData, salvarErrors, salvarIsLoading, setSubmitting, requestConsulta]);

  return (
    <>
      {cancelarAiEspecialModal}

      <FormAlert
        formik={formik}
        data={salvarData}
        errors={salvarErrors || assinarErrors}
        isLoading={salvarIsLoading || assinarIsLoading}
        dismissible
      />
      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow">
            {formik.values.tipoAutoInfracao && (
              <Row className="text-right pt-3">
                <Col>
                  <Button
                    variant="primary"
                    className="btn btn-sm mr-3"
                    disabled={!formik.isValid}
                    onClick={formik.handleSubmit}
                  >
                    Salvar
                  </Button>{" "}
                  <Button
                    variant="primary"
                    className="btn btn-sm mr-3"
                    disabled={!formik.isValid}
                    onClick={() => {
                      assinarAtividade();
                    }}
                  >
                    Assinar
                  </Button>
                  {"   "}
                  {(dadosAIEspecial[0]?.sequencialAutoAberto > 0 || dadosAuto.sequencialAutoAberto > 0) && (
                    <Button
                      variant="primary"
                      className="btn btn-sm mr-3"
                      disabled={!formik.isValid}
                      onClick={() => {
                        setShowModalCancelar({
                          show: true,
                          numeroAuto:
                            dadosAIEspecial[0]?.numeroAutoAberto !== null
                              ? dadosAIEspecial[0]?.numeroAutoAberto
                              : dadosAuto.numeroAutoAberto,
                        });
                      }}
                    >
                      Cancelar
                    </Button>
                  )}
                </Col>
              </Row>
            )}

            <div className="card-body">
              <Row>
                <Form.Group as={Col} sm={12} md={3}>
                  <Form.Label>
                    <b>Tipo de AI Especial </b>
                  </Form.Label>
                  <SelectInput
                    formik={formik}
                    field="tipoAutoInfracao"
                    options={[
                      { key: "", value: "", text: "" },
                      { value: "D", text: "Auto de Infração por Desacato" },
                      { value: "E", text: "Auto de Infração por Embaraço" },
                    ]}
                    disabled={dadosAIEspecial[0]?.tipoAutoAberto}
                  />
                </Form.Group>
              </Row>
              {(formik.values.tipoAutoInfracao || sequencialAuto > 0) && (
                <>
                  <FormOcorrencia
                    formik={formik}
                    tipoAutoInfracao={
                      dadosAIEspecial[0]?.tipoAutoAberto
                        ? dadosAIEspecial[0]?.tipoAutoAberto
                        : formik.values.tipoAutoInfracao
                    }
                    sqItemOcorrencia={
                      dadosAIEspecial[0]?.sqItemOcorrencia
                        ? dadosAIEspecial[0]?.sqItemOcorrencia
                        : formik.values.sqItemOcorrencia
                    }
                    dadosOs={dadosOsRef.current}
                    dadosAIEspecial={dadosAIEspecial}
                    dadosAuto={dadosAuto}
                    propsOcorrencia={dadosOcorrencia}
                  />
                  <br />
                  <Row>
                    <Form.Group as={Col} sm={12} md={12}>
                      <FormRelCircunstanciado formik={formik} />
                    </Form.Group>
                  </Row>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default TelaAIEspecialInicial;
